import React from 'react';
import { CandidatesTabsEnum } from './RecruiterCandidatesContainer2';
import { sendTrackingEvent } from 'src/utils/gtm';
import { useLocation } from 'react-router-dom';
interface Props {
	tab: CandidatesTabsEnum;
	setTab: (arg: CandidatesTabsEnum) => void;
	totalRecommendations: number;
	totalAutoRecommended?: number;
	totalConections: number;
	totalRejected?: number;
	onChange?: (value: CandidatesTabsEnum) => void;
	isTourActive: boolean;
}

const RecruiterCandidatesTabsComponent = ({
	isTourActive,
	tab,
	setTab,
	totalRecommendations,
	totalAutoRecommended = 0,
	totalConections,
	totalRejected = 0,
	onChange,
}: Props) => {
	const location = useLocation();
	return (
		<>
			<div className="flex w-full md:max-w-[600px] dark:bg-[#1F2A37]">
				<button
					className={`walkthrough-first-element ${tab === CandidatesTabsEnum.AUTO_RECOMMENDED
						? 'bg-[#1C1C28] dark:bg-[#18222D] text-white '
						: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
						} !py-2 md:!py-3 flex-1 text-center justify-center cursor-pointer !px-[2px] md:!px-0 max-h-fit leading-tight flex flex-col items-center border border-[#555770] border-solid rounded-l-[8px] font-inter text-[12px] md:text-[14px] font-[500]`}
					onClick={() => {
						if (isTourActive) {
							return;
						}
						setTab(CandidatesTabsEnum.AUTO_RECOMMENDED);
						onChange && onChange(CandidatesTabsEnum.AUTO_RECOMMENDED);
					}}
				>
					<span className="block md:inline">Auto Recommended</span>
					<span className="block md:inline">({totalAutoRecommended})</span>
				</button>
				<button
					className={`${tab === CandidatesTabsEnum.RECOMMENDATIONS
						? 'bg-[#1C1C28] dark:bg-[#18222D] text-white'
						: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
						} !py-2 md:!py-3 flex-1 text-center justify-center cursor-pointer !px-[2px] md:!px-0 max-h-fit leading-tight flex flex-col items-center border-t border-b border-[#555770] border-solid font-inter text-[12px] md:text-[14px] font-[500]`}
					onClick={() => {
						if (isTourActive) {
							return;
						}
						sendTrackingEvent({
							event: 'recr_dashboard_active',
							eventLabel: location.pathname,
						});
						setTab(CandidatesTabsEnum.RECOMMENDATIONS);
						onChange && onChange(CandidatesTabsEnum.RECOMMENDATIONS);
					}}
				>
					<span className="block md:inline">Recommendations</span>
					<span className="block md:inline">({totalRecommendations})</span>
				</button>
				<button
					className={`walkthrough-second-element ${tab === CandidatesTabsEnum.CONNECTED
						? 'bg-[#1C1C28] dark:bg-[#18222D] text-white '
						: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
						} !py-2 md:!py-3 flex-1 text-center justify-center cursor-pointer !px-[2px] md:!px-0 max-h-fit leading-tight flex flex-col items-center border-t border-b border-[#555770] border-solid font-inter text-[12px] md:text-[14px] font-[500]`}
					onClick={() => {
						if (isTourActive) {
							return;
						}
						sendTrackingEvent({
							event: 'recr_dashboard_closed',
							eventLabel: location.pathname,
						});
						setTab(CandidatesTabsEnum.CONNECTED);
						onChange && onChange(CandidatesTabsEnum.CONNECTED);
					}}
				>
					<span className="block md:inline">Applicants</span>
					<span className="block md:inline">({totalConections})</span>
				</button>
				<button
					className={`${tab === CandidatesTabsEnum.REJECTED
						? 'bg-[#1C1C28] dark:bg-[#18222D] text-white '
						: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
						} !py-2 md:!py-3 flex-1 text-center justify-center cursor-pointer !px-[2px] md:!px-0 max-h-fit leading-tight flex flex-col items-center border border-[#555770] border-solid rounded-r-[8px] font-inter text-[12px] md:text-[14px] font-[500]`}
					onClick={() => {
						if (isTourActive) {
							return;
						}
						setTab(CandidatesTabsEnum.REJECTED);
						onChange && onChange(CandidatesTabsEnum.REJECTED);
					}}
				>
					<span className="block md:inline">Rejected</span>
					<span className="block md:inline">({totalRejected})</span>
				</button>
			</div>
		</>
	);
};

export default RecruiterCandidatesTabsComponent;
